import { motion } from "framer-motion";
import { Shield } from "lucide-react";
import CountdownTimer from "@/components/CountdownTimer";
import CheckoutButton from "@/components/CheckoutButton";

const ease = [0.16, 1, 0.3, 1];

export default function FinalCTASection() {
  return (
    <section
      className="relative overflow-hidden py-40 md:py-56 px-6 text-center"
      data-testid="final-cta-section"
      style={{
        background: `
          radial-gradient(ellipse 80% 50% at 50% 100%, rgba(201,168,76,0.08) 0%, transparent 60%),
          #0A0A0A
        `,
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      {/* Pulsing glow */}
      <motion.div
        className="absolute pointer-events-none"
        style={{
          bottom: "-30%",
          left: "50%",
          x: "-50%",
          width: 1000,
          height: 600,
          background: "radial-gradient(ellipse, rgba(201,168,76,0.12) 0%, transparent 65%)",
        }}
        animate={{ opacity: [0.4, 1, 0.4], scale: [1, 1.12, 1] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="max-w-2xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
        >
          <span className="text-[#E84500] text-xs font-semibold tracking-[0.3em] uppercase">
            Letzte Chance
          </span>
          <h2
            className="text-5xl sm:text-6xl lg:text-7xl font-black text-[#F5F5F7] mt-4 mb-6 leading-tight tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Starte heute.
            <br />
            <span className="text-[#C9A84C]">Für 299€.</span>
          </h2>
          <p className="text-[#86868b] text-lg mb-14 max-w-md mx-auto">
            Nur für kurze Zeit — nach dem 7. September: 499€. Jetzt einsteigen und 200€ sparen.
          </p>
        </motion.div>

        {/* Third countdown */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, ease, delay: 0.1 }}
          className="mb-14"
          data-testid="final-countdown-wrapper"
        >
          <p className="text-[#E84500] text-[11px] font-bold uppercase tracking-[0.25em] mb-5">
            Sonderangebot endet in
          </p>
          <CountdownTimer />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease, delay: 0.2 }}
          className="flex flex-col items-center gap-5"
        >
          <CheckoutButton testId="final-cta-button" />
          <span className="flex items-center gap-2 text-[#86868b] text-sm">
            <Shield className="w-3.5 h-3.5 text-[#C9A84C]" />
            Einmalzahlung · Sofortiger Zugang · Kein Abo
          </span>
        </motion.div>
      </div>
    </section>
  );
}
